import { render } from "./NewsFlashHomeList.vue?vue&type=template&id=49e3a87c&scoped=true"
import script from "./NewsFlashHomeList.vue?vue&type=script&lang=js"
export * from "./NewsFlashHomeList.vue?vue&type=script&lang=js"

import "./NewsFlashHomeList.vue?vue&type=style&index=0&id=49e3a87c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e3a87c"]])

export default __exports__